import { defineMessages } from "react-intl";

export const provisioningMessagesI18n = defineMessages({
    "SignupProvisioning.timeoutText.default": {
        id: "SignupProvisioning.timeoutText.default",
        defaultMessage:
            "<h1>This is taking longer than expected.</h1><p>You should receive an email that your product is ready soon. Once this happens, you can access your product at <href-start>start.atlassian.com</href-start>. If you continue having trouble, <href-support>contact support</href-support>.</p>"
    },
    "SignupProvisioning.inProgressText.default": {
        id: "SignupProvisioning.inProgressText.default",
        defaultMessage: "<p>Personalizing your workspace...</p>"
    },
    "SignupProvisioning.errorPollingText.default": {
        id: "SignupProvisioning.errorPollingText.default",
        defaultMessage:
            "<h1>Something went wrong on our end.</h1><p>Please try <href-reload>refreshing this page</href-reload>. If this continues happening, <href-support>contact support</href-support>.</p>"
    },
    "SignupProvisioning.inProgressText.confluence": {
        id: "SignupProvisioning.inProgressText.confluence",
        defaultMessage: "<p>Creating your Confluence site...</p>"
    },
    "SignupProvisioning.inProgressText.confluence2": {
        id: "SignupProvisioning.inProgressText.confluence2",
        defaultMessage:
            "<p>Setting up your team to work better, together...</p>"
    },
    "SignupProvisioning.inProgressText.confluence3": {
        id: "SignupProvisioning.inProgressText.confluence3",
        defaultMessage: "<p>Personalizing your Confluence space...</p>"
    },
    "SignupProvisioning.inProgressText.confluence4": {
        id: "SignupProvisioning.inProgressText.confluence4",
        defaultMessage: "<p>Adding some finishing touches...</p>"
    },
    "SignupProvisioning.inProgressText.confluence5": {
        id: "SignupProvisioning.inProgressText.confluence5",
        defaultMessage: "<p>Preparing your template...</p>"
    },
    "SignupProvisioning.inProgressText.confluence6": {
        id: "SignupProvisioning.inProgressText.confluence6",
        defaultMessage: "<p>Get ready to create your first page!</p>"
    }
});
